<app-z-dialog
  [title]="'HEADER.USER_MENU.MY_PROFILE' | translate"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<input
  #fileInput
  type="file"
  accept="image/*"
  hidden
  (change)="onFileSelected($event)"
/>

<ng-template #contentTemplate>
  <div class="modal-content">
    <div class="avatar-section">
      <div class="avatar-wrapper">
        <div class="avatar-circle" [class.has-image]="!!user().profileImageUrl">
          @if (user().profileImageUrl) {
            <img [src]="user().profileImageUrl" [alt]="user().fullName" />
          } @else {
            <mat-icon>face</mat-icon>
          }

          @if (imageLoading()) {
            <div class="avatar-loading">
              <mat-spinner diameter="32"></mat-spinner>
            </div>
          }
        </div>

        @if (!imageLoading()) {
          <button
            type="button"
            class="avatar-edit-btn"
            [matMenuTriggerFor]="photoMenu"
            [attr.aria-label]="'HEADER.USER_MENU.PROFILE_IMAGE_CHANGE' | translate"
          >
            <mat-icon>edit</mat-icon>
          </button>

          <mat-menu #photoMenu="matMenu" xPosition="after" class="investor-actions-menu avatar-photo-menu">
            <button mat-menu-item type="button" (click)="openCameraDialog()">
              <mat-icon>photo_camera</mat-icon>
              <span>{{ 'HEADER.USER_MENU.PROFILE_IMAGE_TAKE_PHOTO' | translate }}</span>
            </button>
            <button mat-menu-item type="button" (click)="triggerFileInput()">
              <mat-icon>photo_library</mat-icon>
              <span>{{ 'HEADER.USER_MENU.PROFILE_IMAGE_FROM_GALLERY' | translate }}</span>
            </button>
            @if (user().profileImageUrl) {
              <button mat-menu-item type="button" class="menu-item-danger" (click)="onDeleteImage()">
                <mat-icon>delete_outline</mat-icon>
                <span>{{ 'HEADER.USER_MENU.PROFILE_IMAGE_REMOVE' | translate }}</span>
              </button>
            }
          </mat-menu>
        }
      </div>

      <p class="company-name">{{ user().company }}</p>
    </div>

    <div class="info-divider"></div>
    <div class="info-section">
      <div class="info-group">
        <label>{{ 'COMMON.FULL_NAME' | translate }}</label>
        <span>{{ user().fullName || '-' }}</span>
      </div>

      <div class="info-group">
        <label>{{ 'COMMON.COMPANY' | translate }}</label>
        <span>{{ user().company || '-' }}</span>
      </div>

      <div class="info-group">
        <label>{{ 'COMMON.DOC_LABEL' | translate }}</label>
        <span>{{ user().cpf ? (user().cpf | mask: cpfMask || cnpjMask) : '-' }}</span>
      </div>

      <div class="info-group">
        <label>{{ 'COMMON.EMAIL' | translate }}</label>
        <span>{{ user().email || '-' }}</span>
      </div>
      
      
      <div class="info-group full-width">
        <label>{{ 'COMMON.GROUP' | translate }}</label>
        <span>{{ user().group || '-' }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #buttonsTemplate>
  <z-button
    (click)="onChangePassword()"
    [icon]="'vpn_key'"
    [label]="'HEADER.USER_MENU.CHANGE_PASSWORD' | translate"
    [disabled]="(changePasswordLoading | async) === true"
  >
  </z-button>
</ng-template>
